import * as React from 'react';
import { Button } from 'react-bootstrap';
import ZoomContainer from './ZoomContainer';
import Backdrop from "./Backdrop";

interface IState {
    zoomed: boolean;
    fullScreen: boolean;
    mousePosition: {
        xPercent: number;
        yPercent: number;
    };
}

class ImageZoom extends React.Component<any, IState> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            zoomed: false,
            fullScreen: false,
            mousePosition: {
                xPercent: 0,
                yPercent: 0
            }
        };

        this.toggleZoom = this.toggleZoom.bind(this);
        this.toggleFullScreen = this.toggleFullScreen.bind(this);
    }

    toggleZoom(event: any) {
        let imageHeight = event.currentTarget.offsetHeight;
        let imageWidth = event.currentTarget.offsetWidth;
        let xPercent = event.nativeEvent.offsetX / imageWidth;
        let yPercent = event.nativeEvent.offsetY / imageHeight;

        if (this.props.canZoom) {
            this.setState({
                zoomed: !this.state.zoomed,
                mousePosition: { xPercent, yPercent }
            } as IState);
        }
    }

    toggleFullScreen() {
        if (this.props.canZoom) {
            this.setState({ fullScreen: !this.state.fullScreen } as IState);
        }
    }

    handleClickFavorite = () => {
        const { onClickFavorite, imageId, isImageFavorite } = this.props;
        if (onClickFavorite) {
            onClickFavorite(imageId, isImageFavorite);
        }
    };

    render() {
        const { canZoom, isImageEdited, isImageFavorite, canFavourite } =
            this.props;

        return (
            <div
                className={
                    this.state.fullScreen ? 'zoomable-image fullscreen-view' : 'zoomable-image'
                }
                id="zoomable-image"
            >
                {canZoom ? (
                    <div className="floating-img-control">
                        <Button bsStyle="link" onClick={this.toggleFullScreen}>
                            <i className="material-icons">
                                {!this.state.fullScreen ? 'fullscreen' : 'fullscreen_exit'}
                            </i>
                        </Button>
                    </div>
                ) : null}

                {isImageEdited && canFavourite ? (
                    <div className="floating-img-control floating-favorite">
                        <Button
                            bsStyle="link"
                            className={
                                isImageFavorite ? 'favorite-button--selected' : 'favorite-button'
                            }
                            onClick={this.handleClickFavorite}
                        >
                            <i className="material-icons favorite-icon">
                                {isImageFavorite ? 'favorite' : 'favorite_border'}
                            </i>
                        </Button>
                    </div>
                ) : null}

                {!this.state.zoomed && !this.state.fullScreen && (
                    <img
                        ref={this.imageRef}
                        src={this.props.lowResImageSrc}
                        onDoubleClick={this.toggleZoom}
                        onLoad={this.props.onLoad}
                    />
                )}

                {!this.state.zoomed && this.state.fullScreen && (
                    <img
                        ref={this.imageFullscreenRef}
                        src={this.props.highResImageSrc}
                        onDoubleClick={this.toggleZoom}
                        onLoad={this.props.onLoad}
                    />
                )}

                {this.props.canZoom && this.state.zoomed && (
                    <ZoomContainer
                        imageSrc={this.props.highResImageSrc}
                        toggleZoom={this.toggleZoom}
                        xPercent={this.state.mousePosition.xPercent}
                        yPercent={this.state.mousePosition.yPercent}
                    />
                )}

                {!this.props.loaded ? <Backdrop /> : null}
            </div>
        );
    }
}

function ImageZoomWithFeatureToggle(props) {
    return <ImageZoom {...props} />;
}

export default ImageZoomWithFeatureToggle;
